export default __webpack_public_path__ + "static/media/05.53246c23.jpg";